import React from 'react';
import axios from "axios";
import Chart from "react-apexcharts";
import ReportsError from './ReportsError';
import {
    getFromLocalStorage,
    getGraphColours
} from './Utilities';

class ReportsCrossoverBrandChart extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            brand: this.props.brand,
            percentage: this.props.percentage,
            index: this.props.index,
            colors: getGraphColours()
        }
    }

    render() {
        var difference = 100 - this.state.percentage;
        var params = {
            options: {
                chart: {
                    type: 'donut',
                    id: "report-pie-chart"
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                },
                dataLabels: {
                    enabled: false
                },
                states: {
                    active: {
                        filter: {
                            type: 'none'
                        }
                    }
                },
                colors: [this.state.colors[this.state.index], "#FFF"],
            },
            series: [parseFloat(this.state.percentage), parseFloat(difference.toFixed(2))]
        };
    
        return (
            <Chart
                options={params.options}
                series={params.series}
                type="donut"
                key={this.state.brand.ID}
            />
       );
    };
}

class ReportsCrossoverBrands extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            "brands": null,
            "brandsLoaded": false,
            "error": null
        };
    }

    componentDidMount(){        
        this.getData();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.state.brands && !this.state.brandsLoaded) {
            this.setState({
                brandsLoaded: true
            });   
        }   
    }

    getData(){
        var filters = getFromLocalStorage("report_data");
        if(filters.constructor.name === "String") filters = JSON.parse(filters);

        const brand = (filters.ChooseBrands && typeof filters.ChooseBrands[0] != "undefined") ? filters.ChooseBrands[0] : null;
        var url =  "react/process?endpoint=brand";
        if(brand) url += "/"+brand.ID;
        url += "/crossover?limit=8&turnoffdebug=1&includeonetime=1&hourly_cutoff=1";
        axios.get(url).then(response => this.formatData(response.data));
    }

    formatData(data){   
        var error = data?.error;
        this.setState({
            brands: data?.items || {},
            error: error?.message || null
        });
    }

    render() {
        const brands = this.state.brands;
        if(brands){
            if(Object.keys(brands).length !== 0){
                return (
                    <React.Fragment>
                        <div className="row mt-3 text-center">

                            {brands.map((brand, key) => {
                                return(
                                    <div className="col-md-3 col-4 mt-3" key={key}>
                                        <p className="text-muted font-15 mb-1 text-truncate"><strong>{brand.Name}</strong></p>
                                        <ReportsCrossoverBrandChart brand={brand} percentage={brand.Percentage} index={key} />
                                        <p className="crossbrands-percentage text-muted font-14"><strong>{brand.Percentage}%</strong></p>
                                    </div>
                                );
                            })}

                        </div>
                    </React.Fragment>
                );
            } else {
                return (
                    <ReportsError error={this.state?.error} table="false" type="brands" />
                );
            }
        } else {
            return(
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading big" style={this.props.loaderStyle}></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
        }
        
    }
}

ReportsCrossoverBrands.defaultProps = {
    loaderStyle: {
        "height": "200px"
    }
};

export default ReportsCrossoverBrands;
